import { render, staticRenderFns } from "./template-permission-dialog.vue?vue&type=template&id=7331060d&"
import script from "./template-permission-dialog.vue?vue&type=script&lang=ts&"
export * from "./template-permission-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./template-permission-dialog.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports